var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-gallery-container"},[(_vm.productImages.length > 0)?_c('CustomGallery',{staticClass:"product__gallery",attrs:{"images":_vm.productImages,"enable-zoom":false,"outside-zoom":false,"product":_vm.product,"nuxt-img-config":{
      format: 'webp',
      fit: 'cover',
    },"thumb-nuxt-img-config":{
      format: 'webp',
      fit: 'cover',
    }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }